import { Star } from "lucide-react";

export const Stars = ({ n = 5, className = "" }) => (
  <div className={`flex gap-0.5 ${className}`}>
    {Array.from({ length: n }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-foreground text-foreground" />
    ))}
  </div>
);
